// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__rIDT3","bigColWidth":"Table_bigColWidth__1ikNX","biggerColWidth":"Table_biggerColWidth__aPDUn","row":"Table_row__1qLaj","col":"Table_col__3qISK"};